import { render } from "./StorageImagePicker.vue?vue&type=template&id=3d3f15d8&scoped=true"
import script from "./StorageImagePicker.vue?vue&type=script&lang=js"
export * from "./StorageImagePicker.vue?vue&type=script&lang=js"

import "./StorageImagePicker.vue?vue&type=style&index=0&id=3d3f15d8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3f15d8"]])

export default __exports__